/**
 * Created by Dhanya Akhil on 3/31/2017.
 */
import { Inject, Injectable } from '@angular/core';


@Injectable()
export class ChartConfigService {

  public lineOptions;
  constructor(){

  }

  public lineChartOptions:any = {
    showLines:true,
    responsive : true,
    fill : false,
    elements : {
      line : {
        tension : 0,
        fill : false,
        borderWidth : 1,
        borderColor : "#0A6B7C"

      },
      point : {
        pointStyle : "circle",
        radius : 5
      }
    },
    tooltips: {
      callbacks: {
        enabled: true,
        label: function(tooltipItems, data) {
          var priceValue = tooltipItems.yLabel;
          if (priceValue !== null && priceValue != undefined) {
            return 'IDR: ' + priceValue
          } else {
            return '';
          }
        }
      }
    },
    scales : {
      xAxes : [ {
        gridLines : {
          display : false,
          drawBorder: true,
        },
        ticks : {
          min : 0,
          beginAtZero : true,
          autoSkip: false
        }
      } ],
      yAxes : [ {
        gridLines : {
          display : true,
          drawBorder: true,
        },
        ticks : {
          min : 0,
          beginAtZero : true,
          maxTicksLimit: 12,
          fixedStepSize: 200
        }
      } ]
    }
  };
  public barChartColors:Array<any> = [
    { // first color
      backgroundColor: '#8EE3CE'
    }];
  updateChartOptions(maxValue) {
        this.lineOptions = {
          responsive : true,
          fill : false,
          elements : {
            line : {
              tension : 0,
              fill : false,
              borderWidth : 2,
              borderColor : "#0A6B7C"

            },
            point : {
              pointStyle : "circle",
              radius : 5,
              showLine:true
            }
          },
          tooltips: {

            callbacks: {
              enabled: true,
              label: function(tooltipItems, data) {
                var priceValue = tooltipItems.yLabel;
                if (priceValue !== null && priceValue != undefined) {
                  return 'IDR: ' + priceValue
                } else {
                  return '';
                }
              }
            }
          },
          scales : {
            xAxes : [ {
              gridLines : {
                display : false,
                drawBorder: true
              },
              ticks : {
                min : 0,
                beginAtZero : true,
                autoSkip: false
              }
            } ],
            yAxes : [ {
              gridLines : {
                display : false,
                drawBorder: true
              },
              ticks : {
                min : 0,
                max : maxValue,
                maxTicksLimit: 12,
                beginAtZero : true,
                fixedStepSize: 200
              }
            } ]
          },
          showLines:true
        }
    return this.lineOptions;
  }

}
